import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    descricaoMenu,
} from '../../../business-components/String/String'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    TabsPadrao,
    TabPadrao,
} from '../../../business-components/Tab/Tab'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import {
    dadosCompletosCliente,
} from '../cliente-form/ClienteService'

import formList from '../../../business-rules/List/formList'

import tabFormFormList from '../../../business-rules/List/tabFormFormList'

import {
    MensagemDadosObrigatoriosClienteDevemSerInformados,
} from '../cliente-form/ClienteComp'

import CadastroFormClienteConjuge from '../cadastro-form/CadastroFormClienteConjuge'

import CadastroFormFamiliares from '../cadastro-form/CadastroFormFamiliares'

import RiscosForm from '../riscos-form/RiscosForm'

import FormFormCliente from './FormFormCliente'

import FormFormFamiliares from './FormFormFamiliares'

import CadastroFormObjetivos from '../cadastro-form/CadastroFormObjetivos'

import FormFormPerfilCliente from './FormFormPerfilCliente'

import FormFormPerguntas from './FormFormPerguntas'



const FormForm = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, handleSubmitAutomatico,
    vars, jsonIntegracao, arquivoList, obterArquivoList }) => {
    
    const [tabIndexForm, setTabIndexForm] = useState(values.tabIndexForm)
    const [exibir, setExibir] = useState(false)



    const linhaFormList = pesquisaList(formList, values.idFormList)
    


    useSingleton(async () => {

        if (
                tabFormFormList(vars, linhaFormList, values.formListRadioGroup, values.jsonAcessoCliente,
                    jsonIntegracao).length - 1 < tabIndexForm
        ) {

            setTabIndexForm(0)
        }

        setExibir(true)
    })
    
    
    
    const handleTabChangeForm = (e, value) => {
        values.tabIndexForm = value

        setTabIndexForm(value)

        handleSubmitAutomatico(values)
    }


    
    return (
        exibir
            ?
                <DivForm>
                    <TabsPadrao
                        value={tabIndexForm}
                        onChange={handleTabChangeForm}
                        level={2}
                    >
                        {tabFormFormList(vars, linhaFormList, values.formListRadioGroup, values.jsonAcessoCliente,
                        jsonIntegracao)?.map((item, ind) => (
                            <TabPadrao
                                value={ind}
                                label={item}
                                key={ind}
                                level={2}
                            />
                        ))}
                    </TabsPadrao>
                    {descricaoMenu(tabFormFormList(vars, linhaFormList, values.formListRadioGroup, values.jsonAcessoCliente,
                    jsonIntegracao)[tabIndexForm]) === LABEL.dadosCadastrais && (
                        values.formListRadioGroup === HARDCODE.formListPrimeiraReuniao
                            ?
                                <FormFormCliente
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                    vars={vars}
                                    linhaFormList={linhaFormList}
                                    jsonIntegracao={jsonIntegracao}
                                />
                            :
                                <CadastroFormClienteConjuge
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                    vars={vars}
                                    linhaFormList={linhaFormList}
                                />
                    )}
                    {descricaoMenu(tabFormFormList(vars, linhaFormList, values.formListRadioGroup, values.jsonAcessoCliente,
                    jsonIntegracao)[tabIndexForm]) === LABEL.perfilCliente && (
                        <FormFormPerfilCliente
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            idConfiguracao={vars.idConfiguracao}
                        />
                    )}
                    {descricaoMenu(tabFormFormList(vars, linhaFormList, values.formListRadioGroup, values.jsonAcessoCliente,
                    jsonIntegracao)[tabIndexForm]) === LABEL.familiares && (
                        values.formListRadioGroup === HARDCODE.formListPrimeiraReuniao
                            ?
                                <FormFormFamiliares
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                    linhaFormList={linhaFormList}
                                    jsonIntegracao={jsonIntegracao}
                                />
                            :
                                <CadastroFormFamiliares
                                    values={values} 
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                />
                    )}
                    {descricaoMenu(tabFormFormList(vars, linhaFormList, values.formListRadioGroup, values.jsonAcessoCliente,
                    jsonIntegracao)[tabIndexForm]) === LABEL.objetivos && (
                        <CadastroFormObjetivos
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            vars={vars}
                        />
                    )}
                    {descricaoMenu(tabFormFormList(vars, linhaFormList, values.formListRadioGroup, values.jsonAcessoCliente,
                    jsonIntegracao)[tabIndexForm]) === LABEL.perguntas && (
                        !dadosCompletosCliente(values, vars.jsonConfiguracao, true)
                            ?
                                <MensagemDadosObrigatoriosClienteDevemSerInformados
                                    vars={vars}
                                />
                            :
                                <FormFormPerguntas
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    vars={vars}
                                    //linhaTipoLicenca={vars.linhaTipoLicenca}
                                    //idConfiguracao={vars.idConfiguracao}
                                    //jsonConfiguracao={vars.jsonConfiguracao}
                                    //jsonUsuario={vars.jsonUsuario}
                                    //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                    linhaFormList={linhaFormList}
                                    completo={false}
                                    jsonIntegracao={jsonIntegracao}
                                    arquivoList={arquivoList}
                                    obterArquivoList={obterArquivoList}
                                />
                    )}
                    {descricaoMenu(tabFormFormList(vars, linhaFormList, values.formListRadioGroup, values.jsonAcessoCliente,
                    jsonIntegracao)[tabIndexForm]) === LABEL.riscos && (
                        !dadosCompletosCliente(values, vars.jsonConfiguracao, true)
                            ?
                                <MensagemDadosObrigatoriosClienteDevemSerInformados
                                    vars={vars}
                                />
                            :
                                <RiscosForm
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                />
                    )}
                </DivForm>
            :
                ''
    )
}

export default FormForm